import { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/withRouter';
import Authentication from './../../session';
import { getBranchesLatest } from '../../../store/actions';
import { CancelRed, CrossInBox, EyeIconClasset, GreenCheck, RightMarkInCircle } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import { Badge } from 'primereact/badge';
import BranchesApprovalHierarchy from '../../BaseDropdownComponents/BranchesApprovalHierarchy';

class RequestedRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lazyParams: BasicLazyParams,
            requestedRouteInfo: [],
            isView: false,
            totalRecords: 0,
            globalSearch: '',
            remarks: '',
            isApproved: false,
            isRejected: false,
            selectedRoute: null,
            viewData: [],
            dropdownsData: null
        };
        this.service = new Service();
    }

    componentDidMount() { }

    setDropdownValues = (dropdownsData) => {
        this.setState({ dropdownsData, totalRecords: 0 }, () => this.getRequestedRouteInfo());
    };

    getRequestedRouteInfo = async () => {
        const { dropdownsData, lazyParams, globalSearch } = this.state;

        // branchIds is an array like [branchId], extract the first element
        const branchId = Array.isArray(dropdownsData?.branchIds)
            ? dropdownsData.branchIds[0]
            : dropdownsData?.branchIds;

        if (!branchId) return;

        let academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/transport-route-approval/get-pending-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch || ''}`;

        let payload = {
            academicYear,
            branchId,
            assignedHeirarchy: dropdownsData?.heirarchy
        };

        try {
            this.setState({ isLoading: true, requestedRouteInfo: [] });
            const res = await this.service.post(url, payload, true);

            if (res && res.status && res.res?.status) {
                this.setState({
                    isLoading: false,
                    requestedRouteInfo: res.res.records || [],
                    totalRecords: res.res.totalRecords || 0
                });
                if (!res.res?.records?.length) {
                    this.toast.show({ severity: 'info', summary: 'No records found.', detail: '', life: 3000 });
                }
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res.errMessage || 'Failed to fetch data', life: 3000 });
            }
        } catch (err) {
            this.setState({ isLoading: false });
            console.error(err);
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch route approvals', life: 3000 });
        }
    };

    onRouteApprove = (status) => {
        const { selectedRoute, remarks, dropdownsData } = this.state;

        let payload = {
            ...selectedRoute,
            isApproved: status,
            remarks: remarks,
            handledBy: selectedRoute?.handledBy || [],
            levelAndBranchDetails: dropdownsData?.heirarchy?.adminLevels?.filter(
                (al) => al._id === selectedRoute?.branchId
            )
        };

        let url = `${baseUrlAdmin}/transport-route-approval/approve-route`;
        this.setState({ isLoading: true });

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                        isRejected: false,
                        isApproved: false,
                        selectedRoute: null,
                        remarks: ''
                    }, () => this.getRequestedRouteInfo());
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: res.errMessage || 'Operation failed', life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    onHandleRequestedRouteApprove = (rowData, isConfirmed) => {
        this.setState({
            isApproved: isConfirmed,
            isRejected: !isConfirmed,
            selectedRoute: rowData
        });
    };

    handleView = (rowData) => {
        this.setState({
            isView: true,
            viewData: rowData.stops || []
        });
    };

    onPage = (event) => {
        this.setState({ lazyParams: event }, () => this.getRequestedRouteInfo());
    };

    render() {
        return (
            <div className="ma-main">
                <div className="col-span-1 my-3 mx-5">
                    <BranchesApprovalHierarchy
                        selectedValue={1}
                        setValues={this.setDropdownValues}
                        approvalType={'transportRoute'}
                    />
                </div>

                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.requestedRouteInfo}
                    dataKey="_id"
                    paginator
                    lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    emptyMessage="No route approvals found. Select a branch to view pending approvals."
                >
                    <Column
                        field="routeNo"
                        sortable
                        bodyClassName="text-center"
                        header="Route Number"
                        alignHeader={'center'}
                    />
                    <Column
                        field="routeName"
                        sortable
                        bodyClassName="text-center"
                        header="Route Name"
                        alignHeader={'center'}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Stops"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.length || 0}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Pick Up Location"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.stopName || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Drop Location"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[rowData?.stops?.length - 1]?.stopName || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Route Type"
                        alignHeader="center"
                        body={(rowData) => (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    className="formCancelButton"
                                    style={{
                                        backgroundColor: rowData?.isSpecialRoute ? '#E1F7D8' : '#E1F4FF',
                                        borderWidth: 0,
                                        borderRadius: 15,
                                        padding: '4px 12px',
                                        height: '32px'
                                    }}
                                >
                                    <p style={{ fontSize: 12, color: rowData?.isSpecialRoute ? '#1E6D00' : '#0033CC', margin: 0 }}>
                                        {rowData?.isSpecialRoute ? 'SPECIAL' : 'REGULAR'}
                                    </p>
                                </Button>
                            </div>
                        )}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Requested By"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.requestRaisedUserName || '-'}</p>}
                    />
                    <Column
                        alignHeader={'center'}
                        bodyClassName="text-center"
                        header="Approve / Reject"
                        body={(rowData) => (
                            <div className="flex justify-content-center gap-2">
                                <div className="cursor-pointer" onClick={() => this.onHandleRequestedRouteApprove(rowData, true)}>
                                    <GreenCheck />
                                </div>
                                <div className="cursor-pointer" onClick={() => this.onHandleRequestedRouteApprove(rowData, false)}>
                                    <CancelRed />
                                </div>
                            </div>
                        )}
                    />
                    <Column
                        alignHeader={'center'}
                        bodyClassName="text-center"
                        header="View"
                        body={(rowData) => (
                            <div className="flex justify-content-center gap-2 cursor-pointer" onClick={() => this.handleView(rowData)}>
                                <EyeIconClasset />
                            </div>
                        )}
                    />
                </DataTable>

                {/* Reject Dialog */}
                <Dialog
                    visible={this.state.isRejected}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => (
                        <div className="mt-2 formHeadingInter">
                            <div className="mb-3">
                                <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                            </div>
                            <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Route</p>
                        </div>
                    )}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }}
                                onClick={() => this.onRouteApprove(false)}
                            >
                                <p className="formSubmitButtonText">Reject</p>
                            </Button>
                            <Button
                                className="formCancelButton px-4"
                                style={{ backgroundColor: '#F4F5F6', border: 0 }}
                                onClick={() => this.setState({ isRejected: false, selectedRoute: null })}
                            >
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRejected: false, selectedRoute: null })}
                >
                    <div className="m-3 pt-3">
                        <ClassetTextArea
                            width={'100%'}
                            style={{ height: '119px' }}
                            label={'Remarks:'}
                            placeholder="Enter remarks"
                            value={this.state.remarks}
                            onChange={(e) => this.setState({ remarks: e.target.value })}
                        />
                    </div>
                </Dialog>

                {/* Approve Dialog */}
                <Dialog
                    visible={this.state.isApproved}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => (
                        <div className="mt-2 formHeadingInter">
                            <div className="mb-3">
                                <RightMarkInCircle bgcolor={'#7CDD56'} color={'white'} />
                            </div>
                            <p style={{ fontWeight: 'bold', fontSize: 20 }}>Approve Route</p>
                        </div>
                    )}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#7CDD56', border: 'none' }}
                                onClick={() => this.onRouteApprove(true)}
                            >
                                <p className="formSubmitButtonText">Approve</p>
                            </Button>
                            <Button
                                className="formCancelButton px-4"
                                style={{ backgroundColor: '#F4F5F6', border: 0 }}
                                onClick={() => this.setState({ isApproved: false, selectedRoute: null })}
                            >
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isApproved: false, selectedRoute: null })}
                >
                    <div className="m-3 pt-3">
                        <ClassetTextArea
                            width={'100%'}
                            style={{ height: '119px' }}
                            label={'Remarks:'}
                            placeholder="Enter remarks"
                            value={this.state.remarks}
                            onChange={(e) => this.setState({ remarks: e.target.value })}
                        />
                    </div>
                </Dialog>

                {/* View Stops Dialog */}
                <Dialog
                    visible={this.state.isView}
                    draggable={false}
                    closeOnEscape={true}
                    dismissableMask={true}
                    closable={true}
                    header="Route Stops"
                    style={{ width: '80vw' }}
                    onHide={() => this.setState({ isView: false, viewData: [] })}
                >
                    <DataTable value={this.state.viewData} showGridlines>
                        <Column
                            header="Sl.No"
                            body={(rowData, { rowIndex }) => <Badge value={rowIndex + 1} />}
                            alignHeader={'center'}
                            bodyClassName="text-center"
                        />
                        <Column field="areaName" header="Area Name" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="stopName" header="Stop Name" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="pickUpTime" header="Pick Up Time" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="dropTime" header="Drop Time" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="latitude" header="Latitude" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="longitude" header="Longitude" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="landmark" header="Landmark" alignHeader={'center'} bodyClassName="text-center" />
                        <Column field="transportFee" header="Transport Fee" alignHeader={'center'} bodyClassName="text-center" />
                    </DataTable>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading
});

export default connect(mapStateToProps, { getBranchesLatest })(Authentication(withRouter(RequestedRoute)));
